module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Semibold.e59c7c6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Semibold.woff
// module id = 707
// module chunks = 3